import { useTranslation } from 'react-i18next';
import { EditHolidayInfo } from '@thinknet-gmbh/platform-common-ui';

import { HOLIDAY_MANAGER_PAGES } from 'src/pages/settings/components/holiday-manager/holiday-manager.constants';
import { useHolidayNavigate } from 'src/pages/settings/components/holiday-manager/holiday-manager.hook';

const HolidayManagerEdit = ({ data, onFinish }: { data: any; onFinish: (values: any) => void }) => {
  const { t } = useTranslation(['common', 'settings']);
  const { pageNavigate } = useHolidayNavigate();

  const onFinishEdit = (values: any) => {
    onFinish(values);
    pageNavigate(HOLIDAY_MANAGER_PAGES.details, data._id);
  };

  return (
    <EditHolidayInfo
      t={t}
      pageNavigate={() => pageNavigate(HOLIDAY_MANAGER_PAGES.details, data._id)}
      data={data}
      onFinish={onFinishEdit}
    />
  );
};

export default HolidayManagerEdit;
